/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as SettingDefs from './defs.defs.js'

const $nsid = 'tools.ozone.setting.upsertOption'

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  key: /*#__PURE__*/ l.string({ format: 'nsid' }),
  scope: /*#__PURE__*/ l.string<{ knownValues: ['instance', 'personal'] }>(),
  value: /*#__PURE__*/ l.lexMap(),
  description: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ maxLength: 2000 }),
  ),
  managerRole: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string<{
      knownValues: [
        'tools.ozone.team.defs#roleModerator',
        'tools.ozone.team.defs#roleTriage',
        'tools.ozone.team.defs#roleVerifier',
        'tools.ozone.team.defs#roleAdmin',
      ]
    }>(),
  ),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  option: /*#__PURE__*/ l.ref<SettingDefs.Option>(
    (() => SettingDefs.option) as any,
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Create or update setting option */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output)

export { main }

export const $lxm = $nsid
